// // src/imageStorage.js
// import { get, set } from 'idb-keyval';

// const IMAGES_KEY = 'all_food_images';

// // Save or update image
// export async function saveImageToIndexedDB(foodId, blob) {
//   const images = (await get(IMAGES_KEY)) || [];
//   const filtered = images.filter(img => img.foodId !== foodId); // remove old if exists
//   await set(IMAGES_KEY, [...filtered, { foodId, blob }]);
// }

// // Get image by foodId
// export async function getImageFromIndexedDB(foodId) {
//   const images = (await get(IMAGES_KEY)) || [];
//   return images.find(img => img.foodId === foodId)?.blob || null;
// }

import { get, set, del } from 'idb-keyval';

export async function saveImageToIndexedDB(foodId, blob) {
  await set(`food-img:${foodId}`, blob);
}

export async function getImageFromIndexedDB(foodId) {
  return await get(`food-img:${foodId}`) ?? null;
}

export async function deleteImageFromIndexedDB(foodId) {
  await del(`food-img:${foodId}`);
}

